import { createMapColorThemeContext } from "@app/shared/map-appearance/MapColorThemeContext";
import {
  MEMBERSHIP_COLOR_THEME_AMETHYST,
  MEMBERSHIP_COLOR_SLOT_DEFINITIONS,
  MEMBERSHIP_PRESET_THEMES,
} from "@app/overviews/market-expansion-dashboard/components/membership-map/MembershipColorThemeConstants";

const MembershipColorTheme = createMapColorThemeContext({
  defaultTheme: MEMBERSHIP_COLOR_THEME_AMETHYST,
  localStorageKeySuffix: "market-expansion-membership-color-theme",
  presetThemes: MEMBERSHIP_PRESET_THEMES,
  slotDefinitions: MEMBERSHIP_COLOR_SLOT_DEFINITIONS,
});

export { MembershipColorTheme };